module.exports = __webpack_public_path__ + "static/portfolio-mas-2-27f473cb5e028358a1ce1e4f90576549.jpg";